var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDmllogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 68.98 90.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1c75ba;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m67.47,58.27v.02c-2.82,3.64-8.82,6.71-11.99,8.15t-.02.02l-2.01.84s0,.02-.02.02h-.02L.07,90.27v-23.95c0-.84.5-1.59,1.24-1.88l44.24-18.95s21.75,5.94,21.92,12.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m68.98,33.45v21.05c0-2.4-2.5-4.9-6.32-7.48-1.19-.79-2.4-1.56-3.64-2.25-.02,0-.05,0-.05-.02l-.02-.02c-1.61-.89-3.24-1.68-4.93-2.43-3.02-1.29-6.24-2.68-9.44-4.04-11.79-5.05-23.16-9.96-23.16-9.96l.12,12.93c0,2.72-1.59,5.18-4.06,6.22l-13.8,5.82c-1.76.74-3.69-.57-3.69-2.5V12.17C0,3.53,8.67-2.37,16.55.93l42.7,17.78c5.9,2.45,9.73,8.3,9.73,14.74Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDmllogo);
export default __webpack_public_path__ + "static/media/dmllogo.76a92f6bdf8d81cbdb0000f097da665e.svg";
export { ForwardRef as ReactComponent };